import * as h2Api from '../h2Api'
import * as clusterActions from '../actions/clusterProfile'
import { getOccupationSort, PROFILE_LOG_PERSONALIZATION } from '../actions/clusterProfile'
import * as earlyListingActions from '../actions/early/earlyListing'
import {
  extractIdsFromListingForType,
  POPUP_JOURNAL_COMPLETION
} from '../actions/journals'

const initialState = {
  clusterCache: {},
  selectedCluster: {},
  occupationListing: [],
  clusterFilterToPathway: null,
  showActivityModal: false,
  showPopularityModal: false,
  personalization: {},
  localOpportunities: {},
  localOpportunitiesLoading: false,
  selectedLocalTab: 0
}
const clusterProfile = (state = initialState, action) => {
  switch (action.type) {
    case clusterActions.CLUSTER_SORT_OCCUPATIONS:
      return {
        ...state,
        viewKey: action.key,
        occupationListing: action.listing
      }

    case clusterActions.TOGGLE_MODAL:
      return {
        ...state,
        showActivityModal: action.state
      }

    case clusterActions.PATHWAY_FILTER_SELECTED:
      return {
        ...state,
        clusterFilterToPathway: action.pathway
      }

    case clusterActions.TOGGLE_POPULARITY_MODAL:
      return {
        ...state,
        showPopularityModal: action.state
      }

    case POPUP_JOURNAL_COMPLETION:
      const newJs = extractIdsFromListingForType(
        action.journals,
        action.objectId,
        action.objectTypeId
      )

      return {
        ...state,
        personalization: {
          ...state.personalization,
          journals: newJs
        }
      }

    case PROFILE_LOG_PERSONALIZATION:
      if (h2Api.isSuccess(action)) {
        return {
          ...state,
          personalization: action.restCall.result
        }
      }

      return state

    case clusterActions.RATE_CLUSTER:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result
        const { rating, ...itms } = state.personalization

        return {
          ...state,
          personalization: {
            ...itms,
            ...p
          },
          clusterCache: {
            ...state.clusterCache,
            [action.clusterId]: {
              ...state.clusterCache[action.clusterId]
            }
          }
        }
      }

      return state

    case clusterActions.CLUSTER_SELECT_LOADED:
      return {
        ...state,
        selectedCluster: action.selectedCluster
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          clusterCache: (action.restCall.result.clusterProfiles || []).reduce(function (
            map,
            obj
          ) {
            map[obj.id] = obj

            return map
          },
          {})
        }
      }

    case clusterActions.LOCAL_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedLocalTab: action.selectedLocalTab,
          localOpportunities: p,
          localOpportunitiesLoading: false
        }
      }

      return state

    case clusterActions.LOCAL_LOADING:
      return {
        ...state,
        localOpportunitiesLoading: true
      }

    case clusterActions.CLUSTER_PROFILE_LOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const clust = action.restCall.result

        return {
          ...state,
          selectedCluster: clust.id,
          localOpportunities: clust.opportunities,
          personalization: clust.hasOwnProperty('personalization')
            ? clust.personalization
            : {},
          clusterCache: {
            ...state.clusterCache,
            [clust.id]: clust
          },
          viewKey: 1,
          occupationListing: getOccupationSort(1, action.restCall.result)
        }
      }

      return state

    default:
      return state
  }
}

export default clusterProfile
